import React from 'react';
import PropTypes from 'prop-types';

export default function Push({ title, text, renderIcon, renderButton, className, style }) {
    return (
        <div className={`push ${className}`} style={style}>
            <div className="push-boundaries">
                {renderIcon()}
                <div className="push-content">
                    <span className="push-title">{title}</span>
                    <div className="push-text-container">
                        <p className="push-text" dangerouslySetInnerHTML={{ __html: text }} />
                        {renderButton()}
                    </div>
                </div>
            </div>
        </div>
    );
}

Push.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    title: PropTypes.string,
    text: PropTypes.string,
    renderIcon: PropTypes.func,
    renderButton: PropTypes.func
};
